export const generateSignature = (data: string): string => {
  return btoa(data);
};
